// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"19":"a77ca7fc","127":"b159db32","315":"8ca16d12","319":"31e05fee","464":"d631d805","502":"5fbd46c0"}[chunkId] + ".js";
};